import React from 'react'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Actions
import { toggleListingSearchModal } from 'src/actions/listings'

// Components
import { Button, Text } from 'src/Components'

// Styles
import styles from './SearchBar.module.scss'
import SearchIcon from './SearchIcon'

const SearchBar = () => {
  const dispatch = useDispatch()

  return (
    <Button
      onClick={() => dispatch(toggleListingSearchModal(true))}
      className={styles.searchBarBtn}
    >
      <div className={styles.placeholder}>
        <SearchIcon className={styles.svg} />
        <Text className={styles.cta} element='span'>
          <FormattedMessage
            id='SearchBar.placeholder'
            defaultMessage='Search a city or zipcode'
          />
        </Text>
      </div>
      <div className={styles.goBtn}>
        <Text weight='semibold' variant='neutralCool' variantCount='900'>
          <FormattedMessage
            id='Autocomplete.button.submit'
            defaultMessage='Go'
          />
        </Text>
      </div>
    </Button>
  )
}

export default SearchBar
